<script setup lang="ts">
import { computed } from 'vue';

import { AppTag } from '@libs/ui';

import type { GuestRatingSummary } from './customersRatingTag.model';

interface CustomersRatingTagProps {
  guestRating: GuestRatingSummary;
}
const props = defineProps<CustomersRatingTagProps>();

const guestScore = computed<string>(
  () => `${props.guestRating.overallScoreOverTen} / 10`
);
</script>

<template>
  <AppTag class="customers-rating-tag" type="blue" size="s">
    <template #title>
      <span class="rating">
        {{ guestScore }}
      </span>
      {{ $t('guest_rating', [props.guestRating.numberOfReviews]) }}
    </template>
  </AppTag>
</template>

<style scoped lang="scss">
.customers-rating-tag {
  white-space: nowrap;
  .rating {
    @include font-label-s-bold;
  }
}
</style>
